import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'lo',
    fullName: 'Lao',
    nativeName: 'ລາວ',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "ບາງສິ່ງບາງຢ່າງທີ່ຫນ້າປະຫລາດໃຈກໍາລັງມາ",
    landing_subtitle: "ArgVoid ເປັນແອັບ ແລະສະຕູດິໂອພັດທະນາເກມ. ລໍຖ້າ, ສິ່ງໃຫມ່ຈະມາໃນໄວໆນີ້!",
    select_language: "ເລືອກພາສາ",
    search_placeholder: "ຊອກຫາພາສາ...",
    terms_title: "ເງື່ອນໄຂການໃຫ້ບໍລິການ",
    policy_title: "ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ",
    cookies_title: "ນະໂຍບາຍຄຸກກີ",
    terms_content: `
        <strong>1. ການຍອມຮັບເງື່ອນໄຂ</strong><br>
        ໂດຍການເຂົ້າເຖິງ ArgVoid, ເງື່ອນໄຂການໃຫ້ບໍລິການເຫຼົ່ານີ້ຖືກຍອມຮັບ. ຖ້າເງື່ອນໄຂເຫຼົ່ານີ້ບໍ່ໄດ້ຮັບການຕົກລົງ, ການບໍລິການບໍ່ຄວນຖືກນໍາໃຊ້.<br><br>

        <strong>2. ການໃຊ້ເວທີ</strong><br>
        ArgVoid ແລະຄໍາຮ້ອງສະຫມັກຂອງມັນຖືກສະຫນອງໃຫ້ "ເປັນ" ສໍາລັບຈຸດປະສົງຂໍ້ມູນຂ່າວສານແລະສ້າງສັນ. ການບໍລິການຕ້ອງຖືກໃຊ້ເພື່ອຈຸດປະສົງທີ່ຖືກຕ້ອງຕາມກົດໝາຍເທົ່ານັ້ນ.<br><br>

        <strong>3. ຫ້າມ Conduct</strong><br>
        ການຂຸດຄົ້ນຊ່ອງໂຫວ່ຂອງເວັບໄຊ, spamming, ຫຼືຄວາມພະຍາຍາມການເຂົ້າເຖິງພື້ນຖານໂຄງລ່າງໂດຍບໍ່ໄດ້ຮັບອະນຸຍາດແມ່ນຖືກຫ້າມຢ່າງເຂັ້ມງວດ.<br><br>

        <strong>4. ປະຕິເສດຄວາມຮັບຜິດຊອບ</strong><br>
        ແພລະຕະຟອມແລະການບໍລິການອາດຈະຖືກດັດແປງໄດ້ທຸກເວລາໂດຍບໍ່ມີການແຈ້ງການ. ບໍ່ມີການຮັບປະກັນໃດໆກ່ຽວກັບເວລາຫວ່າງ ຫຼືການໃຫ້ບໍລິການ.
    `,
    policy_content: `
        <strong>1. ການ​ເກັບ​ກໍາ​ຂໍ້​ມູນ</strong><br>
        ແພລະຕະຟອມບໍ່ຕ້ອງການການກວດສອບຜູ້ໃຊ້ຫຼືການສ້າງບັນຊີໃນເວລານີ້. ບໍ່ມີຂໍ້ມູນການລະບຸຕົວຕົນສ່ວນຕົວ (ເຊັ່ນ: ຊື່ ຫຼືທີ່ຢູ່ອີເມວ) ຖືກເກັບກຳຈາກຜູ້ເຂົ້າຊົມ.<br><br>

        <strong>2. ການນຳໃຊ້ Data</strong><br>
        ການວິເຄາະແບບບໍ່ເປີດເຜີຍຕົວຕົນແບບພື້ນຖານອາດຈະຖືກເກັບກໍາເພື່ອເຂົ້າໃຈການເຂົ້າຊົມເວັບໄຊ ແລະປັບປຸງແອັບພລິເຄຊັນ. ຂໍ້ມູນນີ້ບໍ່ໄດ້ເຊື່ອມໂຍງກັບຕົວຕົນຂອງຜູ້ໃຊ້ສ່ວນບຸກຄົນ.<br><br>

        <strong>3. ບໍລິການພາກສ່ວນທີສາມ</strong><br>
        ຜູ້ໃຫ້ບໍລິການພາກສ່ວນທີສາມອາດຈະຖືກໃຊ້ສໍາລັບການບໍລິການໂຮດຕິ້ງແລະການວິເຄາະ. ການປະຕິບັດຄວາມເປັນສ່ວນຕົວຂອງຜູ້ໃຫ້ບໍລິການທີ່ກ່ຽວຂ້ອງເຫຼົ່ານີ້ຄຸ້ມຄອງຂໍ້ມູນທີ່ບໍ່ເປີດເຜີຍຊື່ທີ່ປະມວນຜົນຢູ່ໃນໂຄງສ້າງພື້ນຖານຂອງເຂົາເຈົ້າ.<br><br>

        <strong>4. Data Security</strong><br>
        ມາດຕະການຄວາມປອດໄພທີ່ສົມເຫດສົມຜົນໄດ້ຖືກປະຕິບັດເພື່ອປົກປ້ອງເວທີ. ຢ່າງໃດກໍຕາມ, ບໍ່ມີວິທີການສົ່ງຜ່ານອິນເຕີເນັດແມ່ນປອດໄພທັງຫມົດ.<br><br>
    `,
    cookies_content: `
        <strong>1. ຄຸກກີ້ ແລະບ່ອນເກັບຂໍ້ມູນທ້ອງຖິ່ນແມ່ນຫຍັງ?</strong><br>
        ຄຸກກີ້ ແລະບ່ອນເກັບຂໍ້ມູນທ້ອງຖິ່ນຂອງບຣາວເຊີແມ່ນໄຟລ໌ຂໍ້ມູນຂະໜາດນ້ອຍທີ່ເກັບໄວ້ໃນອຸປະກອນເພື່ອຈື່ຈໍາການຕັ້ງຄ່າການຕັ້ງຄ່າໃນທົ່ວການຢ້ຽມຢາມ.<br><br>

        <strong>2. ຈຸດປະສົງການນຳໃຊ້</strong><br>
        Browser LocalStorage ຖືກໃຊ້ຢ່າງເຂັ້ມງວດເພື່ອບັນທຶກການຕັ້ງຄ່າ, ເຊັ່ນ: <br>
        - ການຕັ້ງຄ່າພາສາ<br>
        - ການ​ຕັ້ງ​ຄ່າ​ການ​ໂຕ້​ຕອບ​ຜູ້​ໃຊ້ (ເຊັ່ນ​: ຮູບ​ລັກ​ຫຼື​ການ​ຕັ້ງ​ຄ່າ​ຫົວ​ຂໍ້​) <br>​
        - cache ຄໍາຮ້ອງສະຫມັກຊົ່ວຄາວ<br><br>

        <strong>3. ບໍ່ມີ Tracking</strong><br>
        ຄຸກກີ້ ແລະບ່ອນເກັບຂໍ້ມູນໃນທ້ອງຖິ່ນບໍ່ໄດ້ໃຊ້ເພື່ອການໂຄສະນາ ຫຼືຈຸດປະສົງການຕິດຕາມຂອງພາກສ່ວນທີສາມ. ຂໍ້ມູນທີ່ຖືກເກັບໄວ້ທັງຫມົດແມ່ນເຂັ້ມງວດສໍາລັບການທໍາງານຫຼັກຂອງ platform.<br><br>

        <strong>4. Control</strong><br>
        ຂໍ້ມູນຂອງຕົວທ່ອງເວັບສາມາດຖືກລຶບລ້າງໄດ້ທຸກເວລາໂດຍຜ່ານການຕັ້ງຄ່າຂອງຕົວທ່ອງເວັບ, ເຊິ່ງຈະປັບການຕັ້ງຄ່າທ້ອງຖິ່ນໃດໆ.
    `,
    cookie_consent_text: "ພວກເຮົາໃຊ້ cookies ພື້ນຖານເພື່ອຮັບປະກັນວ່າເວັບໄຊທ໌ຈະເຮັດວຽກຢ່າງຖືກຕ້ອງ, ເຊັ່ນ: ການຮັກສາເຊດຊັນຂອງທ່ານຢ່າງຫ້າວຫັນ, ບັນທຶກຄວາມມັກພາສາຂອງເຈົ້າ, ແລະການຕັ້ງຄ່າທີ່ກໍາຫນົດເອງອື່ນໆ.",
    read_policy: "ອ່ານນະໂຍບາຍຄຸກກີ",
    support_title: "ຕິດຕໍ່ສະຫນັບສະຫນູນ",
    support_subject_label: "ວິຊາ",
    support_message_label: "ຂໍ້ຄວາມ",
    support_submit_button: "ສົ່ງຂໍ້ຄວາມ",
    support_hint: "ໝາຍເຫດ: ນີ້ຈະເປີດແອັບພລິເຄຊັນອີເມວເລີ່ມຕົ້ນຂອງທ່ານເພື່ອສົ່ງຂໍ້ຄວາມ.",
    support_success_msg: "ກຳລັງເປີດແອັບອີເມວຂອງທ່ານ...",
    support_error_msg: "ສົ່ງຂໍ້ຄວາມບໍ່ສຳເລັດ. ກະລຸນາລອງໃໝ່ໃນພາຍຫຼັງ.",
    explorer_title: "ນັກສຳຫຼວດ",
    history_title: "ປະຫວັດສາດ",
    animation_title: "ພາບເຄື່ອນໄຫວ",
    config_title: "ການຕັ້ງຄ່າ",
    tool_mouse: "ເລືອກ (Ctrl+M)",
    tool_brush: "ແປງ (Ctrl+B)",
    tool_brush_mode: "ໂໝດປິດ/ເປີດ (ແຂງ/ຈະແຈ້ງ)",
    tool_eraser: "Eraser (Ctrl+E)",
    tool_brush_size: "ປັບຂະໜາດແປງ",
    tool_bucket: "ຕື່ມຂໍ້ມູນໃສ່ (Ctrl+F)",
    tool_eyedropper: "ຢາຢອດຕາ",
    tool_grid: "ຕາຂ່າຍ (Ctrl+Shift+B)",
    tool_rotate: "ໝຸນ (Ctrl+Shift+R)",
    tool_flip_h: "ປີ້ນ H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "ກວ້າງ",
    label_height: "ຄວາມສູງ",
    label_frames: "ຈໍານວນກອບ",
    label_animation: "ຮູບແບບສັດ",
    label_background_color: "ສີພື້ນຫຼັງ",
    label_interval: "ໄລຍະຫ່າງ",
    tool_anim_config: "ການຕັ້ງຄ່າອະນິເມຊັນ",
    label_new_width: "ກວ້າງໃໝ່",
    label_new_height: "ຄວາມສູງໃໝ່",
    label_apply: "ສະໝັກ",
    label_colors: "ສີ",
    label_size: "ຂະໜາດ",
    label_tolerance: "ຄວາມທົນທານ",
    val_horizontal: "ລວງນອນ",
    val_vertical: "ຕັ້ງ",
    val_sequence: "ລໍາດັບ",
    val_bounce: "ຕີດ",
    val_random: "ສຸ່ມ",
    val_solid: "ແຂງ",
    val_clear: "ຈະແຈ້ງ",
    action_add_sheet: "ແຜ່ນໃໝ່",
    action_import: "ນຳເຂົ້າ",
    action_export: "ສົ່ງອອກ",
    action_sort_projects: "ຄັດ",
    sort_date_old: "ເກົ່າແກ່ທີ່ສຸດ",
    sort_date_new: "ໃໝ່ລ່າສຸດ",
    sort_name_az: "ຊື່ (A-Z)",
    sort_name_za: "ຊື່ (Z-A)",
    action_new_sprite: "Sprite ໃຫມ່",
    action_new_project: "ໂຄງການໃໝ່",
    modal_save_all_title: "ບັນທຶກການປ່ຽນແປງທັງໝົດ",
    modal_save_all_desc: "ເລືອກຊັບສິນເພື່ອບັນທຶກ:",
    modal_save_selected: "ບັນທຶກທີ່ເລືອກ",
    action_saved: "ບັນທຶກແລ້ວ",
    modal_create_sprite_title: "ສ້າງ Sprite ໃຫມ່",
    modal_create_project_title: "ສ້າງໂຄງການໃຫມ່",
    modal_add_sheet_title: "ເພີ່ມຊີດໃໝ່",
    modal_rename_sheet_title: "ປ່ຽນຊື່ແຜ່ນ",
    modal_rename_sprite_title: "ປ່ຽນຊື່ Sprite",
    modal_delete_sprite_title: "ລຶບ Sprite",
    modal_delete_project_title: "ລຶບໂຄງການ",
    modal_delete_sheet_title: "ລຶບແຜ່ນ",
    placeholder_sprite_name: "ຊື່",
    placeholder_project_name: "ຊື່",
    placeholder_sheet_name: "ຊື່",
    placeholder_new_name: "ຊື່ໃໝ່",
    action_create: "ສ້າງ",
    action_add: "ເພີ່ມ",
    action_rename: "ປ່ຽນຊື່",
    action_duplicate: "ຊໍ້າກັນ",
    action_delete: "ລຶບ",
    action_cancel: "ຍົກເລີກ",
    confirm_delete_sprite: "ທ່ານແນ່ໃຈບໍ່ວ່າຕ້ອງການລຶບ sprite ນີ້?",
    confirm_delete_project: "ທ່ານແນ່ໃຈບໍ່ວ່າຕ້ອງການລຶບໂຄງການນີ້? sprites ທັງຫມົດຈະຖືກລຶບອອກ.",
    confirm_delete_sheet: "ທ່ານແນ່ໃຈບໍ່ວ່າຕ້ອງການລຶບຊີດນີ້?",
    err_select_sprite: "ກະລຸນາເລືອກ sprite ທໍາອິດ.",
    err_select_project: "ກະລຸນາເລືອກໂຄງການກ່ອນ.",
    err_name_empty: "ຊື່ບໍ່ສາມາດຫວ່າງເປົ່າໄດ້.",
    err_sprite_exists: "sprite ທີ່ມີຊື່ນັ້ນມີຢູ່ແລ້ວ.",
    err_project_exists: "ໂຄງການທີ່ມີຊື່ນັ້ນມີຢູ່ແລ້ວ.",
    err_no_content: "ບໍ່ມີເນື້ອຫາໃຫ້ບັນທຶກ.",
    err_no_changes: "ບໍ່ມີການປ່ຽນແປງທີ່ຈະບັນທຶກ.",
    err_delete_last_sheet: "ບໍ່ສາມາດລຶບແຜ່ນສຸດທ້າຍໄດ້.",
    err_extract_frames: "ບໍ່ສາມາດແຍກເຟຣມໃດໆອອກໄດ້.",
    err_indexeddb: "ລົ້ມເຫລວໃນການບັນທຶກໃນເຄື່ອງ. ຕົວທ່ອງເວັບຂອງທ່ານອາດຈະບໍ່ສະຫນັບສະຫນູນ IndexedDB.",
    msg_upload_success: "ອັບໂຫຼດສຳເລັດ: {0}",
    msg_upload_failed: "ການອັບໂຫລດລົ້ມເຫລວ: {0}",
    msg_save_success: "ບັນທຶກສຳເລັດ.",
    msg_saving: "ກຳລັງບັນທຶກ...",
    msg_multi_save_result: "ບັນທຶກຊັບສິນ {0} ແລ້ວ. {1} ລົ້ມເຫລວ.",
    menu_title: "ເມນູ",
    menu_save: "ບັນທຶກ",
    menu_save_all: "ບັນທຶກທັງໝົດ",
    menu_support: "ຕິດຕໍ່ສະຫນັບສະຫນູນ",
    label_local_storage: "ການເກັບຮັກສາທ້ອງຖິ່ນ",
    label_sign_in: "ເຂົ້າສູ່ລະບົບ",
    modal_export_title: "ສົ່ງອອກ Sprite",
    label_filename: "ຊື່ໄຟລ໌",
    label_format: "ຮູບແບບ",
    action_export_confirm: "ສົ່ງອອກ",
};

export default translations;
